export default "__VITE_ASSET__DRID$mb5__"